module.exports = __webpack_public_path__ + "img/10-onebg.a197ac44.jpg";